const addDocumentDelegatedListener = (eventName, elementSelector, handler) => {
  // eslint-disable-next-line listeners/no-missing-remove-event-listener, listeners/no-inline-function-event-listener
  document.addEventListener(eventName, function delegatedEventHandler(e) {
    // loop parent nodes from the target to the delegation node
    for (let { target } = e; target && target !== this; target = target.parentNode) {
      if (target.matches(elementSelector)) {
        handler.call(target, e);
        break;
      }
    }
  }, false);
};

module.exports = {
  addDocumentDelegatedListener
};
